import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api } from "../../lib/chalkApi";
import { ChalkCard, DarkHeader, SectionTitle } from "../../components/chalk/primitives";
import { BackButton } from "./AdminBilling";

export default function AdminAudit() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.adminAudit().then((d) => setRows(d.audit || [])); }, []);
  return (
    <>
      <DarkHeader eyebrow="Admin" title="Audit log" subtitle={`${rows.length} entries`} right={<BackButton onClick={() => navigate(-1)} />} />
      <div style={{ padding: "0 18px 24px" }}>
        <SectionTitle label="Recent actions" />
        {rows.length === 0 ? <div style={{ marginTop: 8, fontSize: 13, color: "var(--chalk-muted)" }}>Empty.</div> :
          rows.map((r) => (
            <ChalkCard key={r.id} style={{ marginTop: 8 }} data-testid={`audit-${r.action}`}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontSize: 13, fontWeight: 500, color: "var(--chalk-board)" }}>{r.action}</div>
                <div style={{ fontSize: 11, color: "var(--chalk-muted)" }}>{r.entity_type}</div>
              </div>
              <div style={{ fontSize: 11, color: "var(--chalk-muted)", marginTop: 4 }}>
                actor: {r.actor_id} · {r.created_at}
              </div>
            </ChalkCard>
          ))
        }
      </div>
    </>
  );
}
